module.exports = __webpack_public_path__ + "media/torsten5.c55a24b9.mp3";